/// <reference path="./TableRecord.d.ts" />

import { StatelessComponent } from 'react';

import StyledComponent from '~/components/Styled/Styled';
import css from './TableRecord.scss';

import Link from '~/components/Link/Link';

// tslint:disable-next-line:variable-name
const TableRecord: StatelessComponent<Props> = props => {
  return (
    <Link route={props.api_uri ? props.api_uri : '#'}>
      <a>
        <div style={props.style} className={`${css.record} row`}>
          {props.children}
        </div>
      </a>
    </Link>
  );
};

TableRecord.defaultProps = { style: null };
TableRecord.displayName = 'TableRecord';

export default StyledComponent(TableRecord, [css]);
